import React from 'react'

import { getScreenSize } from '@pb/utils'
import PropTypes from 'prop-types'
import TrackVisibility from 'react-on-screen'

/**
 * Uses the TrackVisibility component with predefined attributes if we're on mobile
 * This is because a height: 100% CSS rule is applied to the body on large screen sizes
 * which causes the scroll event to not trigger, and therefor not displaying the visibility-tracked
 * item if its not in the viewport initially
 */
const TrackVisibilityOnMobile: React.FC<any> = (props) => {
  if (getScreenSize() === 'medium') {
    return <TrackVisibility partialVisibility once offset={300} {...props} />
  }
  return (
    <div {...props}>
      {props.children({
        isVisible: true,
      })}
    </div>
  )
}

// @ts-expect-error ts-migrate(2339) FIXME: Property 'propTypes' does not exist on type 'typeo... Remove this comment to see the full error message
TrackVisibility.propTypes = {
  children: PropTypes.func.isRequired,
}

export default TrackVisibilityOnMobile
